/* Gadget Bazaar — theme.js
   Cart drawer (AJAX), mobile nav, quantity steppers, scroll reveal, PKR money. */
(function () {
  'use strict';

  var MM = window.MM || {};
  window.MM = MM;
  MM.settings = window.MMSettings || {};

  /* ---------- money ---------- */
  MM.money = function (cents) {
    var n = Math.round((cents || 0) / 100);
    try { return '₨ ' + new Intl.NumberFormat('en-PK').format(n); }
    catch (e) { return '₨ ' + n.toLocaleString(); }
  };

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function lockScroll(lock) { document.documentElement.classList.toggle('no-scroll', lock); document.body.classList.toggle('no-scroll', lock); }

  /* ---------- overlay + drawers ---------- */
  var overlay = null;
  function ensureOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      overlay.addEventListener('click', closeAll);
      document.body.appendChild(overlay);
    }
    return overlay;
  }
  function openDrawer(el) { if (!el) return; ensureOverlay().classList.add('is-open'); el.classList.add('is-open'); lockScroll(true); }
  function closeAll() {
    $all('.cart-drawer, .mobile-nav').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    lockScroll(false);
  }
  MM.closeAll = closeAll;

  /* ---------- cart ---------- */
  MM.getCart = function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); };

  MM.renderCart = function (cart) {
    var countEls = $all('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; });

    var items = $('#cart-drawer-items');
    if (items) {
      if (!cart.items.length) {
        items.innerHTML = '<div class="text-center text-muted" style="padding:3rem 1rem">Your cart is empty.</div>';
      } else {
        items.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
          var variant = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
            .map(function (o) { return o.value; }).join(' · ');
          return '' +
            '<div class="cart-item" data-key="' + it.key + '">' +
              '<img class="cart-item__img" src="' + img + '" alt="' + (it.product_title || '') + '" loading="lazy">' +
              '<div>' +
                '<div class="cart-item__title">' + it.product_title + '</div>' +
                (variant ? '<div class="cart-item__meta">' + variant + '</div>' : '') +
                '<div class="qty mt-2" data-key="' + it.key + '">' +
                  '<button data-qty="dec" aria-label="Decrease">–</button>' +
                  '<input type="text" value="' + it.quantity + '" inputmode="numeric" aria-label="Quantity">' +
                  '<button data-qty="inc" aria-label="Increase">+</button>' +
                '</div>' +
              '</div>' +
              '<div style="text-align:right">' +
                '<div class="price" style="font-size:0.95rem">' + MM.money(it.final_line_price) + '</div>' +
                '<button class="cart-item__remove text-muted" data-remove="' + it.key + '" style="font-size:0.78rem;margin-top:0.4rem;text-decoration:underline">Remove</button>' +
              '</div>' +
            '</div>';
        }).join('');
      }
    }
    var subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = MM.money(cart.total_price);
  };

  MM.refresh = function (open) { return MM.getCart().then(function (c) { MM.renderCart(c); if (open) openDrawer($('.cart-drawer')); return c; }); };

  MM.add = function (id, qty) {
    var btn = document.activeElement;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () { return MM.refresh(true); })
      .catch(function () { if (btn) btn.removeAttribute('disabled'); });
  };

  MM.change = function (key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { MM.renderCart(c); return c; });
  };

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t) { e.preventDefault(); MM.refresh(true); return; }
    var closer = e.target.closest('[data-cart-close], [data-mobile-close]');
    if (closer) {
      // Real navigation links must still navigate — only intercept buttons / placeholder links.
      var href = closer.getAttribute('href');
      if (closer.tagName === 'A' && href && href !== '#') { closeAll(); return; }
      e.preventDefault(); closeAll(); return;
    }
    var mob = e.target.closest('[data-mobile-open]');
    if (mob) { e.preventDefault(); openDrawer($('.mobile-nav')); return; }

    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-add-to-cart');
      if (id) { add.setAttribute('disabled', 'true'); MM.add(id, 1).then(function () { add.removeAttribute('disabled'); }); }
      return;
    }
    var rem = e.target.closest('[data-remove]');
    if (rem) { e.preventDefault(); MM.change(rem.getAttribute('data-remove'), 0); return; }

    var qbtn = e.target.closest('[data-qty]');
    if (qbtn) {
      e.preventDefault();
      var wrap = qbtn.closest('.qty');
      var input = wrap.querySelector('input');
      var val = parseInt(input.value, 10) || 1;
      val = qbtn.getAttribute('data-qty') === 'inc' ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      var key = wrap.getAttribute('data-key');
      if (key) MM.change(key, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* product-form (PDP) handled by product-form.js; listen for its submit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (form && form.hasAttribute('data-ajax-cart')) {
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'true');
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return MM.refresh(true); })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    }
  });

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = $all('[data-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    MM.getCart().then(MM.renderCart);
  });
})();
